import { createStore, applyMiddleware } from 'redux'
import rootReducer from "./reducers/rootReducers";
import thunk from 'redux-thunk'
import logger from "./middleware/logger";

const store = createStore(rootReducer, applyMiddleware(thunk, logger))

export default store